import { render } from "./bannerNoticeDetail.vue?vue&type=template&id=ec7ea7d8&scoped=true"
import script from "./bannerNoticeDetail.vue?vue&type=script&lang=js"
export * from "./bannerNoticeDetail.vue?vue&type=script&lang=js"

import "./bannerNoticeDetail.vue?vue&type=style&index=0&id=ec7ea7d8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec7ea7d8"]])

export default __exports__